export default __webpack_public_path__ + "static/media/award.f2a31c23.png";